// extracted by mini-css-extract-plugin
export default {"btns":"styles_btns__Jat9p","btn":"styles_btn__-5SS2","offset":"styles_offset__l8EO2"};